import { useI18n } from "../../i18n";

export const MarqueeBand = () => {
  const { t } = useI18n();
  const items = t("marquee.items");
  const row = items.map((txt, i) => (
    <span key={i} className="flex items-center shrink-0">
      <span className={`font-heading font-bold text-5xl lg:text-7xl tracking-tighter px-8 ${i % 2 === 0 ? "outline-text" : "text-white/90"}`}>
        {txt}
      </span>
      <span className="text-gold text-3xl">•</span>
    </span>
  ));

  return (
    <section className="py-16 overflow-hidden border-y border-white/10 select-none" data-testid="marquee-section" aria-hidden="true">
      <div className="marquee-track">
        <div className="flex shrink-0">{row}</div>
        <div className="flex shrink-0">{row}</div>
      </div>
    </section>
  );
};

export default MarqueeBand;
